import { render } from "./SelectionTool.vue?vue&type=template&id=144bd058&scoped=true"
import script from "./SelectionTool.vue?vue&type=script&lang=js"
export * from "./SelectionTool.vue?vue&type=script&lang=js"

import "./SelectionTool.vue?vue&type=style&index=0&id=144bd058&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-144bd058"]])

export default __exports__